import { render, staticRenderFns } from "./VideoGalleryBlock.vue?vue&type=template&id=64578a68&scoped=true&"
import script from "./VideoGalleryBlock.vue?vue&type=script&lang=js&"
export * from "./VideoGalleryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64578a68",
  null
  
)

export default component.exports